(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less", "../_mixins/foscheckbox"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"), require("../_mixins/foscheckbox"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index, global.foscheckbox);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index, _foscheckbox) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "fos-checkbox",
        on: {
          "click": _vm.handlerClick
        }
      }, [_c('div', {
        staticClass: "fos-checkbox-inside",
        class: _vm.radioClass,
        style: {
          '--color-fos-checkbox': _vm.checkboxColor
        },
        attrs: {
          "role": "checkbox",
          "tabindex": "-1",
          "aria-checked": _vm.checked,
          "aria-disabled": _vm.isDisabled
        }
      }, [_vm.hasCheck ? _c('span', {
        ref: "icon",
        staticClass: "fos-checkbox__icon"
      }, [_c('span', {
        staticClass: "fos-checkbox__icon-init",
        class: _vm.iconClass
      }, [_vm.checked ? _c('span', {
        staticClass: "selected-icon",
        class: _vm.hasAnim ? 'hasAnim' : 'noAnim'
      }) : _vm._e()])]) : _vm._e(), _c('span', {
        ref: "label",
        staticClass: "fos-checkbox__label",
        class: _vm.labelClass
      }, [_vm._t("default")], 2)])]);
    },
    name: 'fos-checkbox',
    mixins: [(0, _foscheckbox.CheckboxMixin)({
      parent: 'fosCheckParent',
      role: 'checkbox'
    })],
    props: {
      hasCheck: {
        type: Boolean,
        default: true
      },
      checkboxColor: {
        type: String,
        default: ''
      },
      manualControl: {
        type: Boolean,
        default: false
      }
    },
    data: function data() {
      return {
        toggleTask: null,
        hasAnim: false
      };
    },
    computed: {
      checked: {
        get: function get() {
          return this.parent ? this.parent.value.indexOf(this.name) !== -1 : this.value;
        },
        set: function set(val) {
          if (this.parent) {
            this.setParentValue(val);
          } else {
            this.animation = true;
            this.$emit('input', val);
          }
        }
      },
      checkIcon: function checkIcon() {
        return this.checked ? 'square-select-os4' : 'square-os4';
      }
    },
    watch: {
      checked: function checked() {
        this.animation = true;
      },
      value: function value(val) {
        this.animation = true;
        this.$emit('change', val);
      }
    },
    methods: {
      // 该方法对外暴露，业务组件直接调用，必须传入原始的点击事件e
      handlerManualChange: function handlerManualChange(event) {
        if (this.manualControl) {
          this.onClick(event);
        }
      },
      handlerClick: function handlerClick(event) {
        if (this.manualControl) {
          this.$emit('manualClickEvent', event);
          return;
        } else {
          this.onClick(event);
        }
      },
      toggle: function toggle() {
        var _this = this;

        this.hasAnim = true;
        var checked = !this.checked;
        clearTimeout(this.toggleTask);
        this.toggleTask = setTimeout(function () {
          _this.checked = checked;
        });
      },
      setParentValue: function setParentValue(val) {
        var parent = this.parent;
        var value = parent.value.slice();

        if (val) {
          if (parent.max && value.length >= parent.max) {
            parent.$emit('showMaxTip');
            return;
          }
          /* istanbul ignore else */


          if (value.indexOf(this.name) === -1) {
            this.animation = true;
            value.push(this.name);
            parent.$emit('input', value);
          }
        } else {
          var index = value.indexOf(this.name);
          /* istanbul ignore else */

          if (index !== -1) {
            this.animation = true;
            value.splice(index, 1);
            parent.$emit('input', value);
          }
        }
      }
    },
    mounted: function mounted() {
      this.hasAnim = !this.checked;
    }
  };
  _exports.default = _default;
});